import InputMask from 'react-input-mask';

// Type-safe wrapper for react-input-mask
const MaskedInput = InputMask as any;

export default MaskedInput;
